/*
    This should contain exactly the same as the config coming from the database tables:
    - layerCategories should map to what exists inside pam_3_0_0.map_category table
    - layerGroups should map to what exists inside pam_3_0_0.map_group table
    - layers should map to what exists inside pam_3_0_0.map_layer table
    The app will only use this config in case something fails when retrieving the actual config from the DB
*/

const mockMapConfig = {
  layerCategories: [
    {
      key: 'cat_unit_detail_basemaps',
      name: 'Basemaps',
      hidden: false,
      openness: 'open',
      opacity: 1,
      layerGroups: ['grp_basemaps'],
      multiphasic: false,
      selectiveness: 'monoselective',
      defaultSelection: ['lyr_esri_topo'],
    },
    {
      key: 'cat_unit_detail_data',
      name: 'Unit Details',
      hidden: false,
      openness: 'open',
      opacity: 1,
      layerGroups: ['grp_unit_detail'],
      multiphasic: true,
      selectiveness: 'polyselective',
      defaultSelection: ['unit_details'],
    },
  ],
  layerGroups: [
    {
      key: 'grp_basemaps',
      name: null,
      openness: 'open',
      layers: [
        'lyr_esri_streets',
        'lyr_esri_world_image',
        'lyr_esri_topo',
        'lyr_esri_light_gray',
      ],
      order: 10,
    },
    {
      key: 'grp_unit_detail',
      name: null,
      openness: 'open',
      layers: [
        'unit_details',
      ],
      order: 10,
    },
  ],
  layers: [
    {
      key: 'lyr_esri_light_gray',
      name: 'Light Gray',
      zIndex: 10,
      hidden: false,
      opacity: 1,
      xyz: {
        maxZoom: 19,
        minZoom: 3,
        endpoints: [
          {
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
            bbox: null,
            zIndex: 10,
            tokenKey: null,
            layerDefs: null,
            layersToShow: null,
          },
        ],
      },
    },
    {
      key: 'lyr_esri_streets',
      name: 'Streets',
      zIndex: 20,
      hidden: false,
      opacity: 1,
      xyz: {
        maxZoom: 19,
        minZoom: 3,
        endpoints: [
          {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
            bbox: null,
            zIndex: 10,
            tokenKey: null,
            layerDefs: null,
            layersToShow: null,
          },
        ],
      },
    },
    {
      key: 'unit_details',
      name: 'Unit details',
      zIndex: 30,
      hidden: false,
      opacity: 1,
      esriFeature: {
        maxZoom: 19,
        minZoom: 3,
        endpoints: [
          {
            url: 'https://500agemrv.timmons.com/server/rest/services/Hosted/SouthDakotaForestry_DEV/FeatureServer/3',
            bbox: null,
            zIndex: 100,
            tokenKey: null,
            layerDefs: null,
            layerToShow: 'unit:details',
          },
        ],
      },
    },
    {
      key: 'lyr_esri_topo',
      name: 'Topo',
      zIndex: 30,
      hidden: false,
      opacity: 1,
      xyz: {
        maxZoom: 19,
        minZoom: 3,
        endpoints: [
          {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
            bbox: null,
            zIndex: 10,
            tokenKey: null,
            layerDefs: null,
            layersToShow: null,
          },
        ],
      },
    },
    {
      key: 'lyr_esri_world_image',
      name: 'Aerial',
      zIndex: 40,
      hidden: false,
      opacity: 1,
      xyz: {
        maxZoom: 19,
        minZoom: 3,
        endpoints: [
          {
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            bbox: null,
            zIndex: 10,
            tokenKey: null,
            layerDefs: null,
            layersToShow: null,
          },
        ],
      },
    },
  ],
};

module.exports = {
  mockMapConfig,
};
